import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import isManager from '../utils/isManager';

function ManagerRoute() {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return null;
  }
  return user && isManager(user.authority_level) ? (
    <Outlet />
  ) : (
    <Navigate to="/consulta" />
  );
}

export default ManagerRoute;
